import type { RawPageConfig } from '~/types/page-config'
import production from '~/configs/production'
import staging from '~/configs/staging'
import development from '~/configs/development'
import local from '~/configs/local'

const allConfigs: Record<string, RawPageConfig[]> = {
  production,
  staging,
  development,
  local,
}

export const getPageConfig = (environment: string, hostname: string, pathname: string) => {
  const configs = allConfigs[environment]
  if (configs === undefined) {
    throw new Error(`Unsupported environment "${environment}".`)
  }
  const config = configs.find((config) => {
    if (typeof config.domain === 'string') {
      if (config.domain !== hostname) {
        return false
      }
    } else if (Array.isArray(config.domain)) {
      if (!config.domain.includes(hostname)) {
        return false
      }
    } else if (!config.domain.test(hostname)) {
      return false
    }

    if (config.path) {
      if (!pathname.startsWith(config.path)) {
        return false
      }
    }

    return true
  })
  return config
}

